module.exports = __webpack_public_path__ + "static/National2Web-Bold-c75c1b5babb60629346747b3611cc05d.woff";